import { Api } from "@relode/core";

import { TagMatch } from "../../../types";
import { TagSuggestRequest } from ".";

export const tagsLookupService = {
    loadSuggestions: async (
        criteria: TagSuggestRequest,
        signal?: AbortSignal | string
    ): Promise<TagMatch[]> => {
        const url = "/tags/suggest";
        const result = await Api.url(url)
            .body({
                ...criteria,
            })
            .retries(3)
            .useSignal(signal)
            .track({ name: "suggest", data: { criteria } })
            .post<TagMatch[]>();
        return result;
    },
};
